import axios from "axios";
import CryptoJS from "crypto-js";
import { getToken } from "../common/utils";
import Globals from "../common/global";
import { logOutRedirectCall } from "../common/RedirectPathManage";

const secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
const IV = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV);
const axiosClient = axios.create({
  baseURL: Globals.API_END_POINT,
  headers: {
    "api-key": bodyEncryption(process.env.REACT_APP_API_KEY),
    "Accept-Language": "en",
    "Content-Type": "text/plain",
    "user-type": "admin",
  },
});

// Helper function for safe JSON parsing
const safeJSONParse = (value) => {
  try {
    // Remove trailing semicolon if present
    const cleanValue = value.trim().replace(/;$/, '');
    return JSON.parse(cleanValue);
  } catch {
    return value;
  }
};

// Body Encryption Function
function bodyEncryption(data, isStringify = false) {
  const dataToEncrypt = isStringify || typeof data !== "string" 
    ? JSON.stringify(data) 
    : data;

  return CryptoJS.AES.encrypt(dataToEncrypt, secretKey, { iv: IV }).toString();
}

// Body Decryption Function
function bodyDecryption(data) {
  // Handle empty/undefined data
  if (!data || typeof data !== 'string' || data.trim() === '') {
    return {}; // Return empty object if no data
  }

  try {
    const bytes = CryptoJS.AES.decrypt(data, secretKey, { iv: IV });
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    
    // Check if decryption was successful
    if (!decryptedText) {
      console.error("Decryption failed: Empty decrypted text");
      return {};
    }
    
    const parsed = safeJSONParse(decryptedText);
    return parsed;
  } catch (error) {
    console.error("CryptoJS Decryption Error:", error.message);
    return {}; // Return empty object on error
  }
}

// Request Interceptor
axiosClient.interceptors.request.use(function (request) {
  request.data = bodyEncryption(request.data, true);
  const token = getToken();
  if (token) {
    request.headers["token"] = bodyEncryption(token);
  }
  return request;
});

// Response Interceptor
axiosClient.interceptors.response.use(
  function (response) {
    const decryptedResponse = bodyDecryption(response.data);

    // Optional: Handle specific response codes
    // if (decryptedResponse.code === 400) {
    //   showErrorMessage(decryptedResponse.message);
    // }

    return decryptedResponse;
  },

  function (error) {
    let res = error.response;
    
    if (!error.response) {
      return Promise.reject(error);
    }

    if (res.status === 401) {
      logOutRedirectCall();
      const response = bodyDecryption(res.data);
      return response;
    } else if (
      res.status === 400 ||
      res.status === 409 ||
      res.status === 500 ||
      res.status === 404 ||
      res.status === 422
    ) {
      const response = bodyDecryption(res.data);
      return response;
    } else {
      console.error(
        "Looks like there was a problem. Status Code: " + res.status
      );
      return Promise.reject(error);
    }
  }
);

export { axiosClient };